"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeycloakSession = void 0;
/* eslint-disable complexity */
const base_1 = require("../../../framework/session/base");
const storage_1 = require("../../../framework/session/storage");
class KeycloakSession extends base_1.BaseSession {
    constructor(store) {
        super(new storage_1.SessionStorage(store));
        this.isDataValid = (sessionData) => {
            var _a, _b, _c, _d;
            if (((_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.accessToken) === null || _a === void 0 ? void 0 : _a.trim()) !== '' &&
                ((_b = sessionData === null || sessionData === void 0 ? void 0 : sessionData.agentToken) === null || _b === void 0 ? void 0 : _b.trim()) !== '' &&
                ((_c = sessionData === null || sessionData === void 0 ? void 0 : sessionData.refreshToken) === null || _c === void 0 ? void 0 : _c.trim()) !== '' &&
                ((_d = sessionData === null || sessionData === void 0 ? void 0 : sessionData.username) === null || _d === void 0 ? void 0 : _d.trim()) !== '') {
                return true;
            }
            return false;
        };
    }
    doRefresh() {
        throw new Error('Method not implemented.');
    }
}
exports.KeycloakSession = KeycloakSession;
//# sourceMappingURL=index.js.map